import React from "react";
import "../../styles/hero.css";
import { useTranslation } from "react-i18next";

// import HeroImage from "../../assets/images/hero.png";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-wrapper">
          <div className="hero-content">
            <div>
              <h2>{t("HERO_TITLE_1")} </h2>
              <h2 className="highlight"> {t("HERO_TITLE_2")}</h2>
            </div>

            <p className="description">{t("HERO_DESC")}</p>
            <p className="description"></p>

            <div className="hero-btns">
              <a className="primary-btn">{t("GET_STARTED")}</a>
              <a className="secondary-btn">{t("DISCOVER_MORE")}</a>
            </div>
          </div>

          {/* <div className="hero-img">
            <img src={HeroImage} />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
